import React,  { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

// Create a context
const MyContext = createContext();

// Create a provider component 
const MyContextProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const [languageData, setLanguageData] = useState(i18n.language);
    const [selNetworkg, setSelNetworkg] = useState(undefined);
    const [selSiteg, setSelSiteg] = useState(undefined);
    const [showSearch, setShowSearch] = useState(false);
    const [showSearchResult, setShowSearchResult] = useState(false);
    const [showDetailsResult, setShowDetailsResult] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({});
    const [searchFilter, setSearchFilter] = useState({});
    const [searchFacets, setSearchFacets] = useState([]);
    const [selectedForDetails, setSelectedForDetails] = useState({});
    const [jwtToken, setJwtToken] = useState(undefined);
    const [recaptchaToken, setRecaptchaToken] = useState(undefined);
    const [address, setAddress] = useState({});
    const [addressValidated, setAddressValidated] = useState({});
    const [recaptcha3Validated, setRecaptcha3Validated] = useState(false);
    const [getSessionId, setSessionId] = useState(undefined);
    const [redirectGenericSite, setRedirectGenericSite] = useState(false);

    const [searchPageNumber, setSearchPageNumber] = useState(1);
    const [sortBy, setSortBy] = useState("distance");
    const [fullZip, setFullZip] = useState("");
    const [sessionTimeExp, setSessionTimeExp] = useState(false);
    const [tokenSessionTime, setTokenSessionTime] = useState(undefined);
   

    const setLanguageSwitchedData = (data) => {        
        setLanguageData(data);        
    }
    
    const getLanguageSwitchedData = () => {
        return languageData;
    }
    
    
    const setSelectedForDetailsData = (data) => {        
        setSelectedForDetails(data);        
    }

    const getSelectedForDetailsData = () => {
        return selectedForDetails;
    }
    
    const setSelectedNetworkData = (data) => {        
        setSelNetworkg(data);        
    }

    const getSelectedNetworkData = () => {
        return selNetworkg;
    }

    
    const setSelectedSiteData = (data) => {        
        setSelSiteg(data);        
    }

    const getSelectedSiteData = () => {
        return selSiteg;
    }
    const setShowSearchData = (data) => {
        setShowSearch(data);

    }
    const getShowSearchData = () => {
        return showSearch;

    }
   

    const setShowSearchResultData = (data) => {
        setShowSearchResult(data);

    }
    const getShowSearchResultData = () => {
        return showSearchResult;

    }

    const setShowDetailResultData = (data) => {
        setShowDetailsResult(data);

    }
    const getShowDetailResultData = () => {
        return showDetailsResult;

        
    }
    const setSearchCriteriaData = (data) => {
        setSearchCriteria(data);

    }
    const getSearchCriteriaData = () => {
        return searchCriteria;

    }

    const setSearchPageNumberData = (data) => {
        setSearchPageNumber(data);

    }
    const getSearchPageNumberData = () => {
        return searchPageNumber;

    }
    const setSearchFilterData = (data) => {
        setSearchFilter(data);

    }
    const getSearchFilterData = () => {
        return searchFilter;

    }

    const setSearchFacetsData = (data) => {
        setSearchFacets(data);

    }
    const getSearchFacetsData = () => {
        return searchFacets;
    }
    const setJwtTokenData = (data) => {
        setJwtToken(data);
        if(data === "") {
            setRecaptcha3Validated(false);
        }
    }
    const getJwtTokenData = () => {
        return jwtToken;
    }
   
    const setRecaptchaTokenData = (data) => {
        setRecaptchaToken(data);
    }
    const getRecaptchaTokenData = () => {
        return recaptchaToken;
    }
    const setAddressData = (data) => {
        setAddress(data);
    }
    const getAddressData = () => {
        return address;
    }

    const setAddressValidatedData = (data) => {
        setAddressValidated(data);
    }
    const getAddressValidatedData = () => {
        return addressValidated;
    }

    const setRecaptcha3ValidatedData = (data) => {
        setRecaptcha3Validated(data);
    }
    const getRecaptcha3ValidatedData = () => {
        return recaptcha3Validated;
    }  

    const setSessionIdData = (data) => {
        if(data==true)
        {
            setSessionId(uuidv4()); 
        } 
        else
        {
            setSessionId(""); 
        }     
    }

    const setSortByData = (data) => {
        setSortBy(data);

    }
    const getSortByData = () => {
        return sortBy;
        
    }

    const getSessionIdData = () => {
        return getSessionId;
    }
    const setFullZipData = (data) => {
        setFullZip(data);
    }
    const getFullZipData = () => {
        return fullZip;
    }
    const setSessionTimeExpData = (data) => {
        setSessionTimeExp(data);
    }
    const getSessionTimeExpData = () => {
        return sessionTimeExp;
    }
    const setTokenSessionTimeData = (data) => {
        setTokenSessionTime(data);
    }
    const getTokenSessionTimeData = () => {
        return tokenSessionTime;
    }
    const setRedirectGenericSiteId = (data) => {
        setRedirectGenericSite(data);
    }
    const getRedirectGenericSiteId = () => {
        return redirectGenericSite;
    }

   return (

        <MyContext.Provider data-testid="global-context" value={{ setLanguageSwitchedData, getLanguageSwitchedData, languageData,
            setSelectedNetworkData, getSelectedNetworkData, selNetworkg,
            setSelectedSiteData, getSelectedSiteData, selSiteg, showSearch, setShowSearchData, getShowSearchData,
            getShowSearchResultData, showSearchResult, setShowSearchResultData,
            getSearchCriteriaData, searchCriteria, setSearchCriteriaData,
            setSelectedForDetailsData, getSelectedForDetailsData, selectedForDetails,
            getShowDetailResultData, showDetailsResult, setShowDetailResultData, setSearchPageNumberData, getSearchPageNumberData , searchPageNumber,
            getSearchFilterData, searchFilter, setSearchFilterData, getSearchFacetsData, searchFacets, setSearchFacetsData,
            getJwtTokenData, jwtToken, setJwtTokenData, getRecaptchaTokenData, recaptchaToken, setRecaptchaTokenData,
            getAddressData, address, setAddressData, getRecaptcha3ValidatedData, recaptcha3Validated, setRecaptcha3ValidatedData,setSessionIdData, getSessionIdData,
            getAddressValidatedData, addressValidated, setAddressValidatedData,
            setSortByData, getSortByData, sortBy, setFullZipData, getFullZipData, fullZip,
            setSessionTimeExpData, getSessionTimeExpData, sessionTimeExp, setTokenSessionTimeData, getTokenSessionTimeData, tokenSessionTime,
            setRedirectGenericSiteId,getRedirectGenericSiteId,redirectGenericSite
        }}>
            {children}
        </MyContext.Provider>
    )

};
MyContextProvider.propTypes = {
    children: PropTypes.string
}
export { MyContext, MyContextProvider };